import { observer } from 'mobx-react-lite'
import { BugAntIcon } from '@heroicons/react/24/outline'
import { useCallback, useState } from 'react'

import { env } from '@/env'
import { webAppState } from '@/appState'

import { DebugButton } from './DebugButton'
import { DebugCheckbox } from './DebugCheckbox'

import type { DebugAction, DebugOptionsType } from './types'

export const DebugOptions = observer(({ actions = [] }: { actions?: DebugAction[] }) => {
    const [open, setOpen] = useState(false)

    const { debugOptions } = webAppState

    const updateDebugOptions = useCallback((updatedOptions: Partial<DebugOptionsType>) => {
        webAppState.debugOptions = { ...webAppState.debugOptions, ...updatedOptions }
        webAppState.keyValueStorage.set('debug.options', updatedOptions)
    }, [])

    return (
        <>
            {open && (
                <div className="absolute right-0 top-full h-96 w-60 overflow-auto rounded-lg border border-neutral-300 bg-white p-2 shadow-lg dark:border-neutral-700 dark:bg-neutral-900">
                    <div className="flex h-full flex-col gap-2">
                        <DebugCheckbox
                            label="Log TRPC calls"
                            checked={debugOptions.logTRPCCalls}
                            onToggle={(checked) => {
                                updateDebugOptions({ logTRPCCalls: checked })
                            }}
                        />
                        <DebugCheckbox
                            label="Hide Upcoming Features"
                            checked={debugOptions.hideUpcomingFeatures}
                            onToggle={(checked) => {
                                updateDebugOptions({ hideUpcomingFeatures: checked })
                                location.reload()
                            }}
                        />
                        <DebugCheckbox
                            label="Hide Scrollbars"
                            checked={debugOptions.hideScrollbars}
                            onToggle={(checked) => {
                                updateDebugOptions({ hideScrollbars: checked })
                                location.reload()
                            }}
                        />

                        <div className="flex-1" />
                        {actions.map((action) => (
                            <button
                                key={action.label}
                                className="rounded bg-red-500 py-1 text-xs font-medium text-white hover:bg-red-700"
                                onClick={action.onClick}
                            >
                                {action.label}
                            </button>
                        ))}
                        <button
                            className="rounded bg-red-500 py-1 text-xs font-medium text-white hover:bg-red-700"
                            onClick={() => {
                                throw new Error('This is a test error')
                            }}
                        >
                            Throw an error
                        </button>
                        {env.VITE_PRODUCT_RELEASE && (
                            <div className="text-xs text-white">
                                SHA: {`${env.VITE_PRODUCT_RELEASE}`.substring(0, 7)}
                            </div>
                        )}
                        {env.VITE_PRODUCT_RELEASE_TIME && (
                            <div className="text-xs text-white">
                                Timestamp: {env.VITE_PRODUCT_RELEASE_TIME}
                            </div>
                        )}
                    </div>
                </div>
            )}
            <DebugButton
                Icon={BugAntIcon}
                onClick={() => {
                    setOpen((open) => !open)
                }}
            />
        </>
    )
})
